<template>
    <div class="completion">
        <img class="img" src="https://staticwecom.beautyfarm.com.cn/20251126/completion.png" alt="">
        <div class="tip">审核成功，报告正在生成中</div>

        <div class="btn" @click="toHistory">查看历史报告</div>
    </div>
</template>

<script>
    export default {
        name: 'Completion',
        data() {
            return {

            }
        },
        methods: {
            toHistory() {
                const { storeId } = this.$route.query
                this.$router.replace({
                    path: '/CRM/inspectStore',
                    query: { activeName: 'reports', storeId }
                });
            }
        }
    }
</script>

<style lang='less' scoped>
    .completion {
        height: 100%;
        font-size: 40px;
        padding-top: 360px;
        text-align: center;
        color: #35434c;
        background-color: #fff;
        overflow-y: scroll;

        .img {
            width: 280px;
            height: 280px;
        }

        .tip {
            margin-top: 20px;
            font-weight: 500;
        }


        .btn {
            position: fixed;
            left: 50%;
            bottom: 100px;
            width: 520px;
            line-height: 90px;
            font-size: 32px;
            color: #fff;
            background-color: #333F48;
            transform: translateX(-50%);
            border-radius: 44px;
        }
    }
</style>
